import "./OurTeam.module.css";
import Header from "@/reusable_sections/Header";
import MedicalLeadership from "./sections/MedicalLeadership";
import OurPhilosophy from "./sections/OurPhilosophy";
import Footer from "@/reusable_sections/Footer";
export default function OurTeamPage() {
  return <div>
      <Header />
      <MedicalLeadership />
      <OurPhilosophy />
      <Footer />
    </div>;
}